"use client"

import { create } from 'zustand'
import type { AuthSnapshot } from '@/lib/auth-state'

type AuthStatus = 'loading' | 'authenticated' | 'anonymous'

type AuthStore = {
  user: AuthSnapshot | null
  status: AuthStatus
  setLoading: () => void
  setUser: (user: AuthSnapshot | null) => void
  clearUser: () => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  status: 'loading',
  setLoading: () => set({ status: 'loading' }),
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'anonymous' }),
  clearUser: () => set({ user: null, status: 'anonymous' }),
}))
